  <template>
  <div>
   <b-modal style="padding:15px" size="lg" id="AddShipmentOtherModal" ref="modal" title="Add Shipment (Other)" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddShipmentOtherForm != undefined ? !this.$refs.AddShipmentOtherForm.checkValidity() : true">
        <form ref="AddShipmentOtherForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-6">
               <b-form-group  label="Shipment Date" label-for="datepicker-2" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "ShipmentDate" placeholder="Choose a date" local="en" required :readonly = "IsReadOnly"></b-form-datepicker>
               </b-form-group>
            </div>  
            <div class = "col-md-6">
              <b-form-group  label="Voucher No" label-for="voucherno" autocomplete="off">
                <b-form-input id="voucherno" v-model= "VoucherNo"  required :readonly = "IsReadOnly"></b-form-input>
              </b-form-group>
            </div>
            <div class = "col-md-6">
              <b-form-group  label="Truck No" label-for="truckno" autocomplete="off">
                <b-form-input id="truckno" v-model= "TruckNo"  required  :readonly = "IsReadOnly"></b-form-input>
              </b-form-group>
            </div>
           
            <div class="col-md-6">
              <b-form-group label="Client" label-for="Client" autocomplete="off">
                <b-form-select v-model= "SelectedClientId" :options="clientsList" value-field="id" text-field="companyName" required :disabled = "IsReadOnly">
                  <b-form-select-option :value = null disabled hidden>Select Client</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
              
              <div class="col-md-6">
                <b-form-group label="Product" label-for="Product" autocomplete="off">
                  <b-form-select v-model= "SelectedFlourId" :options="flourTypes" value-field="id" text-field="name" @change = "getOtherFlourWeights()" required>
                    <b-form-select-option :value = null disabled hidden>Select Type</b-form-select-option>
                  </b-form-select>
                </b-form-group>
            </div>
             <div class="col-md-6">
              <b-form-group label="Bag Type" label-for="BagType" autocomplete="off">
                <b-form-select v-model= "SelectedBagId" :options="bags" value-field="flourWeight.id" text-field="flourWeight.weight" required>
                  <b-form-select-option :value = null disabled hidden>Select Bag</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
           
             <div class = "col-md-6">
              <b-form-group  label="No Of Sacks" label-for="sacks" autocomplete="off">
                <b-form-input id="sacks" v-model= "NoOfSacks" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
             <div class = "col-md-6">
              <b-form-group  label="Unit Price" label-for="FlourUnitPrice" autocomplete="off">
                <b-form-input id="FlourUnitPrice" v-model= "FlourUnitPrice"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col" style = "text-align:end">
             <b-button  style = "margin:10px" @click="addToShipmentList()" :disabled= "this.$refs.AddShipmentOtherForm != undefined ? !this.$refs.AddShipmentOtherForm.checkValidity() : true" variant="primary">Add</b-button>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
            </div>
          </div>
         <b-card>
            <table class="table table-striped table-borderless cutom-table table-grey table-striped table-sm" 
              style="font-size: 85%;">
                <thead>
                  <tr>
                    <th role="columnheader">Product</th>
                    <th role="columnheader">Bag Type </th>
                     <th role="columnheader">Quantity</th>
                    <!-- <th role="columnheader">Inventory Transaction</th> -->
                    <th role="columnheader">Client</th>
                    <th role="columnheader">Unit Price</th>
                    <th role="columnheader">Receiveable</th>
                    <th role="columnheader" >Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
                  <tr v-if= "shipmentEntries.length<=0" >
                    <td class = "center-td" colspan="8">No Items Added</td>
                  </tr>
                  
                <tr v-else v-for="entry in shipmentEntries" :key=entry.id>
                  <td  role="cell">{{entry.FlourName}}</td>
                  <td  role="cell">{{entry.FlourWeight}}</td>
                  <td  role="cell">{{entry.NoOfSacks}}</td>
                  <!-- <td  role="cell">{{entry.IsInventory == true  ? 'true':'false'}}</td> -->

                  <td  role="cell">{{entry.Client}}</td>
                   <td  role="cell">{{entry.FlourUnitPrice}}</td>
                    <td  role="cell">{{entry.Receiveable}}</td>
                
            
                  <td>
                    <span @click= "passRecordToDelete(entry.Id)">
                      <i role="button" style="color:green" class="far fa-trash-alt"></i>
                    </span>       
                  </td>
                </tr>
              </tbody>
            </table>
            <div class = "col-md-4" style ="float:right">
              <b-form-group  label="Cash Payment" label-for="cashpay" autocomplete="off">
                <b-form-input id="cashpayment" v-model= "CashPayment" required></b-form-input>
              </b-form-group>
            </div>
        </b-card>
          
        </form>
      </b-modal>
      <Toaster ref ="toaster"/>
      </div>
      </template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'AddShipmentOther',
    mounted()
    {
      this.getOtherFlourTypes();
      this.getClients();
     
      // console.log(this.$auth.user())
    },
    components:{
      Toaster
    },
    data(){
        return{
          moduleName:'Add Shipment (Other)',   
          ShipmentDate:null,

          VoucherNo: null,
          TruckNo : null,
          NoOfSacks: 1,
          SelectedClientId:null,
          clientsList:[],
      
          SelectedFlourId:null,
          flourTypes:[],
          SelectedBagId:null,
          bags:[],
          IsInventoryTransaction:true,
          FlourUnitPrice:0,
          CashPayment:0,


          shipmentEntries:[],
          EntryId:0,
          IsReadOnly:false
     
		}
  },
  
methods:{
  passRecordToDelete(id)
  {
   
    let index = this.shipmentEntries.findIndex(x=>x.Id == id)
  
    this.shipmentEntries.splice(index, 1); 
   
  },
  addToShipmentList()
  {
    let duplicate = this.shipmentEntries.findIndex(x=>x.FlourTypeId == this.SelectedFlourId && x.FlourWeightId == this.SelectedBagId)
    if(duplicate != -1)
    {
      this.$refs.toaster.showToast('Error','danger','Same flour type and weight already exist');
      return;
    }
    if(this.SelectedClientId == null)
     {
       this.$refs.toaster.showToast('Error','danger','Please select client');
       return;
     }
     if(this.SelectedBagId == null || this.SelectedFlourId == null)
      {
        this.$refs.toaster.showToast('Error','danger','Please select product and bag');
        return;
      }
    if(this.ShipmentDate == null)
      {
        this.$refs.toaster.showToast('Error','danger','Please choose a valid date');
        return;
      }

    
    let selectedClient = this.clientsList.find(x=>x.id == this.SelectedClientId);
    let clientName = selectedClient != null ? selectedClient.companyName:"";

    let selectedFlour = this.flourTypes.find(x=>x.id == this.SelectedFlourId);
    let flourName = selectedFlour != null ? selectedFlour.name:"";

    let selectedBag = this.bags.find(x=>x.flourWeightId == this.SelectedBagId);
    let bagWeight = selectedBag != null ? selectedBag.flourWeight.weight:"";
    
    
          
    let model = {
     //for backend
      NoOfSacks:parseFloat(this.NoOfSacks),
      FlourTypeId:this.SelectedFlourId,
      FlourWeightId:this.SelectedBagId,
      FlourUnitPrice:parseFloat(this.FlourUnitPrice),
      //for front end
      Client:clientName,
      FlourName:flourName,
      FlourWeight:bagWeight,
      IsInventory:this.IsInventoryTransaction,
      Receiveable:this.FlourUnitPrice*this.NoOfSacks,
      Id:this.EntryId //for delete purposes from list
      
    }
    
    this.EntryId++;
 
    this.shipmentEntries.push(model);
    this.IsReadOnly = true;
    this.SelectedFlourId = null;
    this.SelectedBagId = null;
  },

   getClients()
   {
    let model = {
            "CompanyId":this.$auth.user().companyId,
            
          }
          axios.post('/client/getall', model)
          .then(res=>{
         
            this.clientsList = res.data.data
          });
   },

  
    getOtherFlourTypes()
   {
    let model = {
            "CompanyId":this.$auth.user().companyId,
            "BaseType":2
          }
          axios.post('/flourtype/getall', model)
          .then(res=>{
        
            this.flourTypes = res.data.data
          });
   },

    getOtherFlourWeights()
   {
     this.SelectedBagId = null;
    let model = {
            "CompanyId":this.$auth.user().companyId,
            "FlourTypeId":this.SelectedFlourId
          }
          axios.post('/flourweighttypelink/getall', model)
          .then(res=>{
         
            this.bags = res.data.data
          });
   },

   AddShipmentOther(){ 
     
     if(this.CashPayment<0)
     {
       this.$refs.toaster.showToast('Error','danger','Please enter a valid cash amount');
       return;
     }
      if(this.ShipmentDate == null)
        {
          this.$refs.toaster.showToast('Error','danger','Please choose a valid date');
          return;
        }

      let model = {
      "IsInventoryTransaction":this.IsInventoryTransaction,
      "ShipmentDate":this.ShipmentDate,
      "VoucherNo":this.VoucherNo,
      "TruckNo":this.TruckNo,
      "ClientId":this.SelectedClientId,
      "CashPayment":parseFloat(this.CashPayment),
      "ShipmentEntries":this.shipmentEntries,
      "IsAdjustmentEntry":false,
      "CompanyId":this.$auth.user().companyId,
      "UserId":this.$auth.user().id
      }
    
     axios.post('/shipment/PrivateAdd', model
      )
      .then(res=>{
      
            if(res.data.status == 1)
            {    
                 this.$refs.toaster.showToast('Sucess','success','Shipment has been added successfully')
                this.$bvModal.hide('AddShipmentOtherModal')
                 this.$parent.getShipmentsOther();      
            }
            else
            {
               this.$refs.toaster.showToast('Error','danger',res.data.msg);
               this.IsReadOnly = false;   
            }
           
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddShipmentOtherForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
           this.VoucherNo= null,
           this. TruckNo = null,
           this.NoOfSacks= 1,
           this.SelectedClientId=null,
          // this. clientsList=[],
        
           this.SelectedFlourId=null,
          //  this.flourTypes=[],
           this.SelectedBagId=null,
          //  this.bags=[],
           this.IsInventoryTransaction=true,
           this.FlourUnitPrice = 0;
           this.CashPayment =  0;
          this. shipmentEntries=[],
          //  this.EntryId=0,
           this.IsReadOnly=false
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.AddShipmentOther()
       
        // this.$nextTick(() => {
        //   //this.$router.go('/phones')
        //   this.$bvModal.hide('AddShipmentOtherdModal')
        
        // })
      },

 

  }
	

}
</script>
